import { render, staticRenderFns } from "./AddAnnotation.vue?vue&type=template&id=5923d01d&scoped=true&"
import script from "./AddAnnotation.vue?vue&type=script&lang=js&"
export * from "./AddAnnotation.vue?vue&type=script&lang=js&"
import style0 from "./AddAnnotation.vue?vue&type=style&index=0&id=5923d01d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5923d01d",
  null
  
)

export default component.exports